import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { environment } from '@env/environment';

@Injectable({ providedIn: 'root' })
export class CustomTitleStrategy extends TitleStrategy {
    constructor(private readonly title: Title) {
        super();
    }

    override updateTitle(snapshot: RouterStateSnapshot): void {
        const title = this.buildTitle(snapshot);
        if (title !== undefined) {
            this.title.setTitle(`${title} - ${environment.appTitle}`);
        } else {
            this.title.setTitle(environment.appTitle);
        }
    }
}
